import { z } from 'zod';

export enum RefGroupTypeEnum {
  Org = 1,
  Demo = 2,
};
export const groupTypeSchema = z.enum(RefGroupTypeEnum);
export type RefGroupType = z.infer<typeof groupTypeSchema>;